import { render, staticRenderFns } from "./BuyerDeleteModal.vue?vue&type=template&id=c71f63e8"
import script from "./BuyerDeleteModal.vue?vue&type=script&lang=js"
export * from "./BuyerDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports